import { CycleCheckerEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
export class CycleCheckerDTO {
    @ApiProperty()
    cycleCheckerId: number;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    physicalQuantity: number;
    @ApiProperty()
    itemCategoryId: number;
    @ApiProperty()
    itemSubCategoryId: number;
    @ApiProperty()
    masterBrandId: number;
    @ApiProperty()
    itemId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    status:CycleCheckerEnum;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    locationId:number;
    @ApiProperty()
    reason:string;
    @ApiProperty()
    previousQuantity:number;
}